<template>
  <div class="home">
    <div class="container">
      <div class="row introduction col-12">
        {{ this.$t("hi_name", { name: this.name }) }}
        <br /><br />
      </div>
      <div v-if="this.error" class="row form-group col-12">
        <span class="red">{{ this.error }}</span>
      </div>
      <form ref="CurbsideRequest" @submit="validateCurbsideRequest">
        <div class="row form-group col-12">
          <label for="phone_number">*{{ this.$t("Mobile Number") }}</label>
          <input
            type="text"
            required
            v-model="phone_number"
            id="phone_number"
            name="phone_number"
            :placeholder="this.$t('Mobile Number')"
            class="input-field form-control"
            :title="this.$t('Mobile Number')"
            :aria-label="this.$t('Mobile Number')"
            value=""
            tabindex="1"
          /><br />
        </div>
        <div
          v-if="['st-hubert', 'swiss', 'montanas', 'burgers-priest'].includes(brand)"
          class="row form-group col-12"
        >
          <label for="parking_lot_number">{{ this.$t("Parking Lot") }}</label>
          <input
            type="text"
            :required="isParkingLotNumberRequired"
            v-model="parking_lot_number"
            id="parking_lot_number"
            name="parking_lot_number"
            :placeholder="this.$t('Parking Lot')"
            class="input-field form-control"
            :title="this.$t('Parking Lot')"
            :aria-label="this.$t('Parking Lot')"
            value=""
            tabindex="1"
          /><br />
        </div>
        <div
          v-if="['swiss', 'burgers-priest'].includes(brand)"
          class="row form-group col-12"
        >
          <select
            required
            class="form-control"
            name="vehicle_type"
            id="vehicle_type"
            v-model="vehicle_type"
          >
            <option selected="selected" value="">
              {{ this.$t("Vehicle Type") }}
            </option>
            <option :selected="vehicle_type === 'car'" value="car">
              {{ this.$t("car") }}
            </option>
            <option :selected="vehicle_type === 'suv'" value="suv">
              {{ this.$t("suv") }}
            </option>
            <option :selected="vehicle_type === 'truck'" value="truck">
              {{ this.$t("truck") }}
            </option>
            <option :selected="vehicle_type === 'minivan'" value="minivan">
              {{ this.$t("minivan") }}
            </option>
          </select>
        </div>
        <div class="row form-group col-12">
          <label for="car_colour">*{{ this.$t("Car Colour") }}</label>
          <input
            type="text"
            :required="isCarColourRequired"
            v-model="car_colour"
            id="car_colour"
            name="car_colour"
            :placeholder="this.$t('Car Colour')"
            class="input-field form-control"
            :title="this.$t('Car Colour')"
            :aria-label="this.$t('Car Colour')"
            value=""
            tabindex="1"
          /><br />
        </div>
        <div class="row form-group col-12">
          <label for="plate_number">{{ this.$t("Plate Number") }}</label>
          <input
            type="text"
            :required="isPlateNumberRequired"
            v-model="plate_number"
            id="plate_number"
            name="plate_number"
            :placeholder="this.$t('Plate Number')"
            class="input-field form-control"
            :title="this.$t('Plate Number')"
            :aria-label="this.$t('Plate Number')"
            value=""
            tabindex="1"
            minlength="3"
          /><br />
        </div>
        <div class="row form-group col-12">
          <label for="car_make">{{ this.$t("Car Make") }}</label>
          <input
            type="text"
            :required="isCarMakeRequired"
            v-model="car_make"
            id="car_make"
            name="car_make"
            :placeholder="this.$t('Car Make')"
            class="input-field form-control"
            :title="this.$t('Car Make')"
            :aria-label="this.$t('Car Make')"
            value=""
            tabindex="1"
          /><br />
        </div>
        <div v-if="brand != 'swiss'" class="row form-group col-12">
          <label for="car_model">{{ this.$t("Car Model") }}</label>
          <input
            type="text"
            :required="isCarModelRequired"
            v-model="car_model"
            id="car_model"
            name="car_model"
            :placeholder="this.$t('Car Model')"
            class="input-field form-control"
            :title="this.$t('Car Model')"
            :aria-label="this.$t('Car Model')"
            value=""
            tabindex="1"
          /><br />
        </div>
        <button class="button">{{ this.$t("Submit") }}</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      store_number: null,
      car_make: null,
      car_model: null,
      car_colour: null,
      plate_number: null,
      parking_lot_number: null,
      vehicle_type: "",
      phone_number: null,
      brand: null,
      brandlogo: null,
      name: null,
      orderNumber: null,
      amount: null,
      emailAddress: null,
      paymentType: null,
      orderTime: null,
      promiseTime: null,
      error: null,
      isrecaptcha2key: this.$recaptchaSiteKey,
      recaptchaToken: this.$recaptchaToken,
      isSTH: this.$globalBrand == "st-hubert",
      isPhoneRequired: true,
      isVehicleTypeRequired: this.$globalBrand == "swiss",
      isCarColourRequired:
        this.$globalBrand == "swiss" || this.$globalBrand == "st-hubert",
      isPlateNumberRequired: this.$globalBrand != "st-hubert",
      isParkingLotNumberRequired: false,
      isCarMakeRequired: false,
      isCarModelRequired: false,
    };
  },
  beforeMount() {
    if (this.$cookies) {
      if (this.$cookies.get("car_make")) {
        this.car_make = this.$cookies.get("car_make");
      }
      if (this.$cookies.get("car_model")) {
        this.car_model = this.$cookies.get("car_model");
      }
      if (this.$cookies.get("car_colour")) {
        this.car_colour = this.$cookies.get("car_colour");
      }
      if (this.$cookies.get("plate_number")) {
        this.plate_number = this.$cookies.get("plate_number");
      }
      if (this.$cookies.get("vehicle_type")) {
        this.vehicle_type = this.$cookies.get("vehicle_type");
      }
    }
  },
  mounted: function () {
    let queryVars = this.$route.query;
    this.name = queryVars.name;
    this.orderNumber = queryVars.orderNumber;
    this.store_number = queryVars.storeNumber;
    this.amount = queryVars.amount;
    this.phone_number = queryVars.phoneNumber;
    this.emailAddress = queryVars.emailAddress;
    this.paymentType = queryVars.paymentType;
    this.orderTime = queryVars.orderTime;
    this.promiseTime = queryVars.promiseTime;

    this.brand = this.$globalBrand;
    this.brandlogo = this.$parent.$data.brandlogo;
  },
  methods: {
    validateCurbsideRequest(e) {
      e.preventDefault();

      let phoneRegex = /^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/;
      phoneRegex = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
      phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

      this.error = "";
      if (!phoneRegex.exec(this.phone_number.replace("-", ""))) {
        this.error = this.$t("invalid_phone");
        return;
      }

      if (this.$refs.CurbsideRequest.checkValidity()) {
        this.submitCurbsideRequest();
      } else {
        this.$refs.CurbsideRequest.reportValidity();
      }
    },

    submitCurbsideRequest() {
      let url = this.$API + "/v1/request";
      let payload = {
        store_number: this.store_number,
        car_make: this.car_make,
        car_model: this.car_model,
        car_colour: this.car_colour,
        plate_number: this.plate_number,
        vehicle_type: this.vehicle_type,
        phone_number: this.phone_number,
        parking_lot_number: this.parking_lot_number,
        order_number: this.orderNumber,
        amount: this.amount,
        name: this.name,
        email_address: this.emailAddress,
        payment_type: this.paymentType,
        order_time: this.orderTime,
        promise_time: this.promiseTime,
        recaptcha: this.recaptchaToken,
        language: this.$parent.lang,
      };

      fetch(url, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: new Headers({
          "x-api-key": this.$TOKEN,
        }),
      })
        .then((stream) => stream.json())
        .then((response) => {
          if (response.error == null || response.error == "") {
            if (this.$cookies) {
              this.$cookies.set("car_make", this.car_make, Infinity);
              this.$cookies.set("car_model", this.car_model, Infinity);
              this.$cookies.set("car_colour", this.car_colour, Infinity);
              this.$cookies.set("plate_number", this.plate_number, Infinity);
              this.$cookies.set("vehicle_type", this.vehicle_type, Infinity);
            }

            this.$router.push({ name: "ThankYou" });
          } else if (response.error == "duplicate") {
            this.error = this.$t("dup_error");
          } else {
            this.error = this.$t("dup_error");
          }
        })
        .catch((error) => {
          if (error.error == "duplicate") {
            this.error = this.$t("Error Text Message");
          }
        });
    },
  },
};
</script>

<style>
.home {
  margin-top: 15px;
}
label {
  display: none;
}
.red {
  color: red;
}
</style>
